import type { JSX } from "react";
import type { Citation } from "@shared/types";
import { IconFile, IconGlobe, IconArrowRight } from "../icons";
import { sourceTypeLabel } from "./CitationChip";

interface RightRailProps {
  citation: Citation;
  onClose: () => void;
}

/**
 * Citation-source preview rail. Opens on demand when a citation chip is
 * clicked (the host only mounts it then), and can be dismissed. Distinguishes
 * an internal KB source from a retrieved web source.
 */
export function RightRail({ citation, onClose }: RightRailProps): JSX.Element {
  const isWeb = citation.url !== undefined && citation.url.length > 0;
  const low = citation.lowConfidence === true;
  return (
    <aside className="rail">
      <div className="rail-head">
        <div className="rail-label">引用预览 · 第 {citation.num} 处</div>
        <button className="rail-close" type="button" aria-label="关闭" onClick={onClose}>
          ×
        </button>
      </div>
      <div className="cite-card">
        <div className="cite-card-source">
          {isWeb ? <IconGlobe size={12} /> : <IconFile size={12} />}
          {citation.title || citation.source}
        </div>
        {citation.snippet && <div className="cite-card-snippet">{citation.snippet}</div>}
        {isWeb && citation.url !== undefined && (
          <a className="cite-card-link" href={citation.url} target="_blank" rel="noreferrer">
            查看完整页面
            <IconArrowRight size={14} />
          </a>
        )}
      </div>
      <div className="rail-meta">
        {citation.score !== undefined && (
          <div className="rail-meta-row">
            <span>检索得分</span>
            <span>{citation.score.toFixed(2)}</span>
          </div>
        )}
        <div className="rail-meta-row">
          <span>来源类型</span>
          <span>{sourceTypeLabel(citation)}</span>
        </div>
        <div className="rail-meta-row">
          <span>用途</span>
          <span>{low ? "可能相关（仅供参考）" : "用于作答"}</span>
        </div>
        <div className="rail-meta-row">
          <span>{isWeb ? "链接" : "分块 ID"}</span>
          <span>{isWeb ? citation.source : citation.id}</span>
        </div>
      </div>
    </aside>
  );
}
